export const rolesTags = {
  ROLES: 'Roles',
  ROLE_RECORD: 'RoleRecord',
  PERMISSIONS: 'Permissions',
};
